import {
    ReactElement,
    createContext,
    useContext,
    useMemo,
    useState,
} from "react"

import { IFile } from "../models/IFile"
import { VIEWER_TYPE } from "../enums"

interface IViewerContext {
    viewerInfo: {
        file: IFile | null
        type: VIEWER_TYPE
    }
    setViewerInfo: React.Dispatch<
        React.SetStateAction<{
            file: IFile | null
            type: VIEWER_TYPE
        }>
    >
}

export const ViewerContext = createContext<IViewerContext>({
    viewerInfo: { file: null, type: VIEWER_TYPE.IMAGE },
    setViewerInfo: () => {},
})

export function ViewerProvider({ children }: { children: ReactElement }) {
    const [viewerInfo, setViewerInfo] = useState<{
        file: IFile | null
        type: VIEWER_TYPE
    }>({ file: null, type: VIEWER_TYPE.IMAGE })

    const value = useMemo(
        () => ({
            viewerInfo,
            setViewerInfo,
        }),
        [viewerInfo],
    )

    return (
        <ViewerContext.Provider value={value}>
            {children}
        </ViewerContext.Provider>
    )
}
export const useViewer = (): IViewerContext => {
    const context = useContext(ViewerContext)
    if (!context) {
        throw new Error("useViewer must be used within a ViewerProvider")
    }
    return context
}
